<div style="text-align: center;">{{ 'shared.' + message | translate }}</div>

<ng-container *ngIf="false">
    {{ 'shared.no_access_to_page' | translate }}
    {{ 'shared.no_access' | translate }}
</ng-container>
